import SelectorModel from '../../../models/SelectorModel';

export function buildTiposTituloSelector(tiposTitulo) {
  return tiposTitulo.map(tipoTitulo => new SelectorModel(tipoTitulo.idTipoTitulo, tipoTitulo.descricaoTipoTitulo));
}
